import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import { FormDataAccessRights } from "../types";
import { SelectedEmployee } from "../types";

interface AddAccessRightsFormEffectsProps {
    selectedEmployeeToAdd: SelectedEmployee;
    isAddAccessRightsModal: boolean;
}

const AddAccessRightsFormEffects: React.FC<AddAccessRightsFormEffectsProps> = ({
    selectedEmployeeToAdd,
    isAddAccessRightsModal,
}) => {
    const { setFieldValue } = useFormikContext<FormDataAccessRights>();

    useEffect(() => {
        if (selectedEmployeeToAdd?.roleId && isAddAccessRightsModal) {
            setFieldValue("roleId", selectedEmployeeToAdd.roleId);
        }
    }, [selectedEmployeeToAdd?.roleId, isAddAccessRightsModal, setFieldValue]);

    return null;
};

export default AddAccessRightsFormEffects;
